import { useStore } from 'zustand';

import type { MediaLightboxState } from './MediaLightboxStore.types';
import { useMediaLightboxStoreContext } from './MediaLightboxStoreContext';

export const useMediaLightboxStore = <T>(selector: (state: MediaLightboxState) => T): T => {
  const store = useMediaLightboxStoreContext();

  return useStore(store, selector);
};
